<template>
  <div class="home">
    smartfund
    <echarts :chartData='chartData' :width="'500px'" :height="'300px'" :className="'echart1'"></echarts>
    <echarts :chartData='chartData' :width="'500px'" :height="'300px'" :className="'echart1'"></echarts>
  </div>
</template>
<script>
import echarts from "../../components/echarts.vue";
export default {
  components: {
    echarts,
  },
  data() {
    return {
      chartData: {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 25,
          top: 30,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [2021,2022,2023],
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          offset: 24,
          axisLabel: {
            formatter: function (value, index) {
              return `${value}`;
            },
            rich: {
              a: {
                width: 140,
                align: "right",
              },
              b: {
                width: 140,
                align: "left",
              },
            },
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: function (e) {
                  if (e > 50) {
                    return "#fd4c4c";
                  } else {
                    return "#fcad2a";
                  }
                },
              },
              formatter: function (value) {
                return value;
              },
            },
            position: "left",
          },
        ],
        series: [
          {
            name: "中估",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#fcad2a",
            data: [1,2,3],
          },
          {
            name: "高估",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#fd4c4c",
            data: [4,5,6],
          },
          {
            name: "低估",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#3cbb73",
            data: [1,5,3],
          },
          {
            name: "不知道是啥",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#539cff",
            data: [4,2,6],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(83,156,255,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(83,156,255,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>

